import { CompositeDecorator } from "draft-js";
import Link from "editor/components/Link";
import { ENTITY_TYPE } from "config/constants/editor";
/**
 * All the special things we add to draft.js.
 */

// Links
export const findLinkEntitites = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    if (entityKey !== null) {
      const entityType = contentState.getEntity(entityKey).getType();
      return (
        entityType === ENTITY_TYPE.LINK || entityType === ENTITY_TYPE.OLD_LINK
      );
    }
    return false;
  }, callback);
};

// Build the decorators.
export const editorDecorators = new CompositeDecorator([
  {
    strategy: findLinkEntitites,
    component: Link,
  },
]);
